/**
 * @module common/components/gallery_tile
 */
import React from 'react';

/**
 * General component to display a no results message in galleries.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const GalleryNoResults = () => (
  <div className="empty-state no-results">
    <div className="empty-state-container">
      <h3 className="text-center">No items to display.</h3>
    </div>
  </div>
);

export default GalleryNoResults;



// WEBPACK FOOTER //
// ./common/components/gallery_no_results.jsx